// src/components/Banner.js
import React, { useState } from "react";
import { Modal, Row, Col } from "antd";
import SignUpModal from "./modals/SignUp";
import SignupModalteacher from "./modals/SignUpteacher";

const Banner = () => {
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);
  const [isTeacherSignUpModalOpen, setIsTeacherSignUpModalOpen] =
    useState(false);

  const [modal, contextHolder] = Modal.useModal();

  return (
    <>
      {contextHolder}

      <Row
        style={{
          margin: 0,
          minHeight: "100vh", // ✅ better than height
          flexWrap: "wrap",
        }}
      >
        <Col
          xs={24}
          md={12}
          className="hero-text-col"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px 20px",
            background: "linear-gradient(135deg, #000 80%, #e6be5d 40%)",
            color: "#fff",
            // height: "100%", // Full height
          }}
        >
          <div style={{ maxWidth: "650px", width: "100%" }}>
            <h1
              style={{
                fontSize: "clamp(1.8rem, 5vw, 3rem)",
                fontWeight: "bold",
                marginBottom: "20px",
                lineHeight: "1.2",
                textAlign: "left",
              }}
            >
              {" "}
              Where Creativity{" "}
              <span style={{ color: "#e6be5d" }}>Becomes Music</span>{" "}
            </h1>{" "}
            <p
              style={{
                fontSize: "clamp(0.9rem, 2.5vw, 1.2rem)",
                marginBottom: "30px",
                textAlign: "left",
                color: "#ddd",
              }}
            >
              {" "}
              Learn production skills and how to create powerful,
              professional-quality music from expert music teachers. Whether
              you’re a beginner or advanced, we help you grow your talent and
              turn your ideas into real sound.{" "}
            </p>{" "}
            <div
              style={{
                display: "flex",
                gap: "12px",
                flexWrap: "wrap", // ✅ stack buttons on mobile
              }}
            >
              {" "}
              <button
                onClick={() => setIsSignUpModalOpen(true)}
                style={{
                  flex: "1 1 100px",
                  maxWidth: "180px",
                  backgroundColor: "#e6be5d",
                  color: "#000",
                  padding: "12px 0px",
                  borderRadius: "6px",
                  border: "none",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "0.3s",
                }}
              >
                {" "}
                Login as Student{" "}
              </button>{" "}
              <button
                onClick={() => setIsTeacherSignUpModalOpen(true)}
                style={{
                  flex: "1 1 100px",
                  maxWidth: "180px",
                  backgroundColor: "transparent",
                  color: "#fff",
                  padding: "12px 0px",
                  borderRadius: "6px",
                  border: "2px solid #e6be5d",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "0.3s",
                }}
              >
                Login as Teacher{" "}
              </button>{" "}
            </div>{" "}
          </div>
        </Col>

        <Col
          xs={24}
          md={12}
          className="hero-image-col"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "250px",
            marginTop: "-0.3rem",
          }}
        >
          <img
            src={require("../assets/hero.jpg")}
            alt="Music Banner"
            style={{
              width: "100%",
              height: "100%", // match parent height
              objectFit: "cover",
            }}
          />
        </Col>
      </Row>

      {/* Sign Up Modal */}
      <SignUpModal
        isOpen={isSignUpModalOpen}
        onClose={() => setIsSignUpModalOpen(false)}
      />
      <SignupModalteacher
        isOpen={isTeacherSignUpModalOpen}
        onClose={() => setIsTeacherSignUpModalOpen(false)}
      />
    </>
  );
};

export default Banner;
